import React, { Component } from 'react';
import StructureTree from './StructureTree';

export default class Structure extends Component {
  componentDidMount() {
    this.props.didMount();
    window.scrollTo(0, 0);
  }

  render() {
    const { structure, isLoading } = this.props;
    return (
      <div>
        <div className="captions">структура образовательной организации</div>
        <StructureTree structure={structure} isLoading={isLoading} />
      </div>
    );
  }
}
